(function () {
  'use strict';

  function initHub(root) {
    var search = root.querySelector('[data-faq-search]');
    var form = root.querySelector('[data-faq-search-form]');
    var clear = root.querySelector('[data-faq-clear-search]');
    var reset = root.querySelector('[data-faq-reset]');
    var status = root.querySelector('[data-faq-status]');
    var empty = root.querySelector('[data-faq-empty]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));

    if (!search || !status) return;

    function update() {
      var query = search.value.trim().toLowerCase();
      var visible = 0;

      items.forEach(function (item) {
        var match = !query || (item.getAttribute('data-search') || '').indexOf(query) !== -1;
        item.hidden = !match;
        if (match) visible += 1;
      });

      groups.forEach(function (group) {
        group.hidden = group.querySelectorAll('[data-faq-item]:not([hidden])').length === 0;
      });

      status.textContent = query
        ? visible + (visible === 1 ? ' matching answer' : ' matching answers')
        : items.length + ' general answers';
      clear.hidden = !query;
      empty.hidden = visible !== 0;
    }

    function resetSearch() {
      search.value = '';
      update();
      search.focus();
    }

    form.addEventListener('submit', function (event) { event.preventDefault(); update(); });
    search.addEventListener('input', update);
    clear.addEventListener('click', resetSearch);
    if (reset) reset.addEventListener('click', resetSearch);

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open && window.history && window.history.replaceState) {
          window.history.replaceState(null, '', '#' + item.id);
        }
      });
    });

    if (window.location.hash) {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target && root.contains(target) && target.matches('[data-faq-item]')) {
        target.open = true;
        window.requestAnimationFrame(function () { target.scrollIntoView({ block: 'start' }); });
      }
    }

    update();
  }

  function initChatTriggers() {
    document.querySelectorAll('[data-faq-chat-trigger]').forEach(function (card) {
      card.addEventListener('click', function (event) {
        var chat = document.querySelector('shopify-chat');
        if (!chat || typeof chat.show !== 'function') return;
        event.preventDefault();
        chat.show();
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-faq-hub]').forEach(initHub);
    initChatTriggers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
